import { DeliveryPlace } from '@bestelleck/utils';

import { Location } from '../types/Geo';

export const getDeliveryPlaceForLocation = (deliveryPlaces: DeliveryPlace[], currentPlaces: Location[]) => {
    return deliveryPlaces.find((place) => {
        return currentPlaces.find((loc) => loc.id === place.locationId);
    });
};
